const ExpandIcon = () => (
  <svg width="11" height="14" viewBox="0 0 11 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M5.49955 0.845703L5.49955 11.8457M5.49955 11.8457L0.845703 7.0057M5.49955 11.8457L10.1534 7.0057" stroke="#4F8CE7" strokeWidth="2"/>
  </svg>
)

export default ExpandIcon
